import React from 'react';
import RowMenu from '../util/RowMenu';
import Modal from '../util/Modal';
import PostLink from '../util/PostLink';
import PropTypes from 'prop-types';

import { IntlProvider } from 'react-intl';
import { translations } from '../util/i18n';
import EditDepartmentModal from "./EditDepartmentModal";

const DepartmentsRowMenu = (props) => {
  const options = [
    {
      title: "departments.dropdown.edit-department",
      component: Modal,
      params: {
        title: "departments.dropdown.edit-department",
        content: EditDepartmentModal({ url: props.updateUrl, details: props.details }),
      },
    },
    {
      title: "departments.dropdown.delete-department",
      component: PostLink,
      params: {
        method: "delete",
        url: props.deleteUrl,
        confirmMessage: "departments.dropdown.delete-department.confirm-message",
        refresh: true,
      },
    }
  ];

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <RowMenu options={options}></RowMenu>
    </IntlProvider>
  );
};

DepartmentsRowMenu.propTypes = {
  updateUrl: PropTypes.string.isRequired,
  deleteUrl: PropTypes.string,
  details: PropTypes.object.isRequired,
};

export default DepartmentsRowMenu;
